import { BaseContext } from "../../utils/basecontext";
import { HttpClient } from "../../utils/httpclient/httpclient";
import { APIRequest } from "../api/apiRequest";
import { APIResponse } from "../api/apiresponse";
import { RewardPointAPI } from "../api/rewardpoint/rewardpointapi";
import { RewardPointGenerateTokenAPI } from "../api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenapi";
import { RewardPointGenerateTokenRequest } from "../api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenrequest";
import { RewardPointGenerateTokenResponse } from "../api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenresponse";
import { RewardPointRequest } from "../api/rewardpoint/rewardpointrequest";
import { RewardPointResponse } from "../api/rewardpoint/rewardpointresponse";
import { APIProcessor } from "../processor/apiProcessor";
import { RewardPointAPIProcessorImpl } from "../processor/rewardpointapiprocessor";
import { RewardPointGenerateTokenAPIProcessorImpl } from "../processor/rewardpointgeneartetokenapiprocessor";
import { ProcessorFactoryImpl } from "./processorfactory";

export class RewardPointProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getRewardPointProcessor():APIProcessor<RewardPointRequest, RewardPointResponse>
    {
        return new RewardPointAPIProcessorImpl(this.getContext(), new RewardPointAPI(this.getHttpClient(), this.getContext()));
    }

    getRewardPointGenerateTokenProcessor():APIProcessor<RewardPointGenerateTokenRequest, RewardPointGenerateTokenResponse>
    {
        return new RewardPointGenerateTokenAPIProcessorImpl(this.getContext(), new RewardPointGenerateTokenAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/rewardpointprocessorfactory.tsx